import React from "react";
import { JobResult } from "../types/job"

type Props = {
  result: JobResult;
  title: string;
  jobTitle: string;
  location: string;
  salary: string;
  postedDate?: string;
}
const JobCard: React.FC<Props> = ({ result }) => {
  const jobId = result.job_id?.raw || "";
  const jobTitle = result?.job_title?.raw ?? result?.job_title ?? "No Title";
  const location = result?.location?.raw ?? result?.location ?? "No Location";
  const salary = result?.salary?.raw ?? result?.salary ?? "No salary";
  const postedDate = result?.posted_date?.raw ?? result?.posted_date ?? null;

  const formattedDate = postedDate
    ? new Date(postedDate).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    : "No Date";
  const jobBaseUrl = document.querySelector('[data-job-base-url]')?.getAttribute('data-job-base-url') || '/find-work';
  const jobLink = `${jobBaseUrl}/${jobId}`;
  const base = "job-card";
  const title= jobTitle.replace(/<\/?em>/g, "");
  const classes = {
    wrapper: base,
    block: `${base}__block`,
    title: `${base}__title`,
    location: `${base}__location`,
    salary: `${base}__salary`,
    separator: `${base}__separator`,
    time: `${base}__time`,
  };
//Check if the job is new (posted within the last 7 days)
    const isNewJob = (postedDate) => {
      const postedDateObj = new Date(postedDate);
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

      return postedDateObj >= sevenDaysAgo;
    };
  return (
    <a href={jobLink} title={title} className={classes.wrapper}>
      <div className={classes.block} role="region" aria-labelledby={`job-title-${jobId}`}>
        <h2 className={classes.title} id={`job-title-${jobId}`}>{jobTitle.replace(/<\/?em>/g, "")}</h2>
        <p className={classes.location}>{location} <span className={classes.separator}> | </span> Permanent </p>
        <p className={classes.salary}>{salary}</p>
        <time
            className={`${classes.time} ${isNewJob(result.posted_date?.raw) ? "job-card__posted--new" : ""}`}
            itemProp="datePublished"
        >
          Posted {formattedDate}
        </time>
      </div>
    </a>

  );
};
export default JobCard;
